import HeatInstallationForm from '@components/components/HeatInstallationForm/HeatInstallationForm';
import React from 'react';

const CmsHeatInstallationForm = ({
  blockId,
  addressPickerLink,
  planningPrice,
  basePrice,
  floorspacePrice,
  radiatorPrice,
  waterDevicePrice,
}) => (
  <HeatInstallationForm
    addressPickerLink={addressPickerLink}
    basePrice={basePrice}
    blockId={blockId}
    floorspacePrice={floorspacePrice}
    planningPrice={planningPrice}
    radiatorPrice={radiatorPrice}
    waterDevicePrice={waterDevicePrice}
  />
);

export default CmsHeatInstallationForm;
